import * as type from './type'

export const facadeGlassHelper = {
  type,
}
